export default "__VITE_ASSET__CoSaKhZ2__"